import DateFnsUtils from '@date-io/date-fns';
import {
  DateTimePicker as MaterialDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import * as React from 'react';
import { DateTimeFormat } from '../../config';

export const DateTimePicker: typeof MaterialDateTimePicker = ({
  value,
  format = DateTimeFormat.SHORT,
  ...rest
}) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <MaterialDateTimePicker
        format={format}
        value={value || null}
        ampm={false}
        placeholder={format && format.toLowerCase()}
        autoOk
        clearLabel={'Clear'}
        cancelLabel={'Cancel'}
        okLabel={'Ok'}
        todayLabel={'Today'}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  );
};
